module.exports = __webpack_public_path__ + "img/icon_im_telegram.aabab9cb.webp";